import dayjs from 'dayjs';
import type {Dayjs} from 'dayjs';

export interface IRelativeDayOfWeekFilterOptions {
	includeTime?: boolean;
	/**
	 * When short is enabled "Today" and "Tomorrow" are returned without the date.
	 */
	short?: boolean;
}

type TFilterFunction = (
	date: Date | Dayjs | string | number,
	options?: IRelativeDayOfWeekFilterOptions,
) => string;

const DEFAULT_OPTIONS: IRelativeDayOfWeekFilterOptions = {
	includeTime: false,
	short: false,
};


const FORMAT_TIME = ' h:mma';

export const RelativeDayOfWeekFilter: TFilterFunction = (date, options?) => {
	const combinedOptions = {
		...DEFAULT_OPTIONS,
		...options,
	};

	const dayJsObj = dayjs(date); // instantiates, converts or clones, as needed
	const today = dayjs();

	if(dayJsObj.isSame(today, 'day')) {
		if(combinedOptions.short) {
			return 'Today';
		} else {
			return `Today, ${dayJsObj.format('MMMM D' + (combinedOptions.includeTime ? FORMAT_TIME : ''))}`;
		}
	} else if(dayJsObj.isSame(today.add(1, 'day'), 'day')) {
		if(combinedOptions.short) {
			return 'Tomorrow';
		} else {
			return `Tomorrow, ${dayJsObj.format('MMMM D' + (combinedOptions.includeTime ? FORMAT_TIME : ''))}`;
		}
	} else {
		return dayJsObj.format('dddd, MMMM D' + (combinedOptions.includeTime ? FORMAT_TIME : ''));
	}
};
